// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SW09ymPYTz811BJEHPRI{justify-content:space-between;padding:12px;display:flex;position:relative}.SW09ymPYTz811BJEHPRI._uXmO5EzNEZ_mLjTaU0Q:before{content:"";background:var(--interaction-neutral-normal);height:1px;position:absolute;top:0;left:12px;right:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SW09ymPYTz811BJEHPRI`,
	"modal": `_uXmO5EzNEZ_mLjTaU0Q`
};
export default ___CSS_LOADER_EXPORT___;
